import React, { Fragment } from "react";
import "./styles.scss";
import cart from "../../images/cart.png";
import truncate from "../../utils/truncate";
import numberToComma from "../../utils/numberToComma";

const StoreItemThemeTwo = (props) => {
  const { photo, name, desc, price, action } = props;
  const addDefaultSrc = (e) => {
    e.target.src = cart;
  };
  return (
    <Fragment>
      <div className="store-item-two-container">
        <div onClick={action}>
          <span className="store-item-two-new-item">NEW</span>
          <div className="store-item-two-image-container">
            <img
              src={photo}
              className="item-two-image"
              width="100%"
              alt="a pic"
              onError={addDefaultSrc}
            />
          </div>
        </div>
        <p className="store-item-two-item-name">{truncate(name, 25)}</p>
        <p className="store-item-two-item-desc">{desc ? truncate(desc, 25) : ""}</p>
        <p className="store-item-two-item-price">₦ {numberToComma(price)}</p>
      </div>
    </Fragment>
  );
};

export default StoreItemThemeTwo;
